import { Box } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import React, { memo, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import OtpInput from "react18-input-otp";
import checkImg from "../../assets/Registration/bd74bd2a9be392ce416f720c99db304a.gif";
import { maskEmail } from "../../lib/utility";
import {
  userOTPVerification,
  userResendEmailOTP,
} from "../../services/authServices";
import success from ".././Registration/success.module.css";
import style from "./Registration.module.css";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
function OTPVerification({ setIsPasswordModal }) {
  const [enterOTP, setEnterOTP] = useState();
  const [isFillAll, setIsFillAll] = useState(false);
  const [isMobileVerify, setIsMobileVerify] = useState(false);
  const [isResendOTP, setIsReSendOTP] = useState(false);
  const [otpSentMsg, setOtpSentMsg] = useState("");
  const navigate = useNavigate();

  const user_id = localStorage.getItem("userId");
  const userDetails = JSON.parse(localStorage.getItem("userInfo"));

  useMemo(() => {
    if (enterOTP?.length >= 4) {
      setIsFillAll(true);
    } else {
      setIsFillAll(false);
    }
  }, [enterOTP]);

  useMemo(() => {
    if (isMobileVerify) {
      setTimeout(() => {
        setIsMobileVerify(false);
        // navigate("/success-registration");
        navigate("/set-password");
      }, 4000);
    }
  }, [isMobileVerify, navigate]);

  const handleChangeOtp = (otp) => {
    setEnterOTP(otp);
  };

  const handleSubmitOTP = () => {
    if (enterOTP?.length == 4) {
      call_OTP_Verification(enterOTP);
    }
  };

  const handleReSendOTP = () => {
    setEnterOTP("");
    callResendOTP();
  };

  const callResendOTP = async () => {
    try {
      const request = await userResendEmailOTP({ user_id });
      const response = await request.data;

      if (response.status == 1) {
        const token = response?.verification_token;
        setIsReSendOTP(true);
        localStorage.setItem("verification_token", token);
      }
      setOtpSentMsg(response?.message || "");
    } catch (error) {
      console.log(error);
    }
  };

  const call_OTP_Verification = async (data) => {
    try {
      const request = await userOTPVerification({ user_id, otp: data });
      const response = await request.data;

      if (response.status === 1) {
        localStorage.setItem(
          "verification_token",
          response?.data?.verification_token
        );
        setIsMobileVerify(true);
      } else {
        setEnterOTP("");
        setIsPasswordModal(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Snackbar
        open={isResendOTP}
        autoHideDuration={2000}
        onClose={() => setIsReSendOTP((prev) => !prev)}
      >
        <Alert
          onClose={() => setIsReSendOTP((prev) => !prev)}
          sx={{
            width: "100%",
            backgroundColor: "white",
            "& .MuiAlert-icon svg": { color: "green" },
            color: "black",
          }}
          severity="success"
        >
          {otpSentMsg}
          {/* OTP has been sent to your registered email address. */}
        </Alert>
      </Snackbar>
      <Box
        style={{
          width: "100vw",
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItem: "center",
          padding: "3rem",
        }}
      >
        {isMobileVerify ? (
          <Box
            className={success.success_container}
            style={{
              height: "50svh",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              position: "relative",
            }}
          >
            <div style={{ position: "absolute", top: "-5%" }}>
              <h4 style={{ fontSize: "1.0625rem", marginBottom: "2rem" }}>
                Email is Verified
              </h4>
              <img src={checkImg} />
            </div>
          </Box>
        ) : (
          <>
            <Box sx={{ textAlign: "center", marginBottom: "2rem" }}>
              <h4 className={style.OTP_Verification_header}>
                Email Verification
              </h4>
            </Box>

            <Box
              style={{
                display: "flex",
                alignItem: "center",
                justifyContent: "center",
                margin: "2rem 0rem",
              }}
            >
              <div className={style.OTP_Verification_desc}>
                <h5>Please enter the OTP sent to your email </h5>
                <h5 style={{ fontWeight: 700 }}>
                  {maskEmail(userDetails?.email || "")}
                  {/* {userDetails?.country_code} ******
                  {userDetails?.mobile_no?.split("").slice(6).join("")} */}
                </h5>
              </div>
            </Box>

            <Box
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <OtpInput
                value={enterOTP}
                onChange={handleChangeOtp}
                isInputSecure
                inputProps={{
                  type: "password",
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }}
                numInputs={4}
                isInputNum={true}
                isSuccessed={false}
                errorStyle="error"
                successStyle="success"
                shouldAutoFocus
                inputStyle={{
                  width: "100%",
                  maxWidth: "50px",
                  marginLeft: "0.7rem",
                  height: "4.6875rem",
                  border: "1px solid rgba(134, 71, 175, 0.20)",
                  boxShadow: "0px 1px 2px 0px rgba(134, 71, 175, 0.20)",
                  borderRadius: "8px",
                  // fontSize: " 1.0625",
                  color: "black",
                  fontWeight: "400",
                  caretColor: "blue",
                  fontSize: "25px",
                  outline: "none",
                }}
                focusStyle={{
                  border: "2px solid black",
                }}
              />
            </Box>
            <h4
              style={{
                textAlign: "center",
                marginTop: "1rem",
                fontSize: " 0.9375rem",
                fontWeight: "400",
                color: "#3F48DD",
                textDecoration: "underline",
              }}
              onClick={handleReSendOTP}
            >
              Resend OTP
            </h4>
            <Box>
              <button
                className={style.submit_otp_button}
                style={
                  isFillAll
                    ? { backgroundColor: "#7F3F97", color: "white" }
                    : { backgroundColor: "#F5F5F5" }
                }
                onClick={handleSubmitOTP}
              >
                Submit OTP
              </button>
            </Box>
          </>
        )}
      </Box>
    </>
  );
}

export default memo(OTPVerification);
